import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../analytics';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  ADD_NEW_USER: '2706',
  CONTINUE_ADDING_NEW_USER: '2707',
  CANCEL_ADDING_NEW_USER: '2708',
  CONTINUE_NEW_USER_ROLE: '2709',
} as const;

// https://dataportal.zillowgroup.net/event-registry/2706
export const emitAddNewUserEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: EVENT_IDS.ADD_NEW_USER,
      event_template_id: '167',
      event_template_version_id: '1',
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'user_management',
      trigger_source_nm: 'add_new_user',
      trigger_object_nm: 'no_trigger_object',
    },
    semantic: {
      semantic_event_nm: 'start_adding_new_user',
      topic_tag_txt: ['zrm_enterprise'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2707
export const emitContinueAddingNewUserEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: EVENT_IDS.CONTINUE_ADDING_NEW_USER,
      event_type_version_id: '2',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'user_management',
      trigger_source_nm: 'continue',
      trigger_object_nm: 'new_user_info',
    },
    semantic: {
      semantic_event_nm: 'continue_adding_new_user',
      topic_tag_txt: ['zrm_enterprise'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2708
export const emitCancelAddingNewUserEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: EVENT_IDS.CANCEL_ADDING_NEW_USER,
      event_type_version_id: '2',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'user_management',
      trigger_source_nm: 'cancel',
      trigger_object_nm: 'new_user_info',
    },
    semantic: {
      semantic_event_nm: 'continue_adding_new_user',
      topic_tag_txt: ['zrm_enterprise'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2709
export const emitContinueNewUserRoleEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackUserEvent({
    envelope: {
      event_type_id: EVENT_IDS.CONTINUE_NEW_USER_ROLE,
      event_type_version_id: '2',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'user_management',
      trigger_source_nm: 'continue',
      trigger_object_nm: 'new_user_role',
    },
    semantic: {
      semantic_event_nm: 'continue_adding_new_user',
      topic_tag_txt: ['zrm_enterprise'],
    },
    ...getZrmUserInfo(user),
  });
